import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Client } from 'app/core/models/client.model';
import { PatientFilters } from 'app/core/models/user-settings/patient-search-settings.model';
import { FormsModule } from '@angular/forms';
import { ClientSelectComponent } from '../../../shared/components/client-select/client-select.component';

@Component({
    selector: 'app-patient-filters',
    templateUrl: './patient-filters.component.html',
    styleUrls: ['./patient-filters.component.scss'],
    imports: [FormsModule, ClientSelectComponent]
})
export class PatientFiltersComponent {
  @Input() filters: PatientFilters;
  @Output() public filtersChange = new EventEmitter<PatientFilters>();

  clients: Client[] = [];

  emitFilterChange() {
    this.filtersChange.emit(this.filters);
  }

  onFormEnter($event) {
    $event.preventDefault();
    this.emitFilterChange();
  }

  onClearAllClick($event) {
    $event.preventDefault();
    this.filters = new PatientFilters();
    this.emitFilterChange();
  }

  onSubmit() {
    this.emitFilterChange();
  }
}
